module.exports = __webpack_public_path__ + "static/media/tool-card-2-icon.c5ae6c7f.svg";